import React, { Component } from 'react';
import * as util from '../../../utils/EnumMapping';
import MainTable from '../../common/table/MainTable';
import Correction from '../correction/NewCorrection';
import * as columns from './CashColumns';


class Cash extends Component {

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "CASH";
            item.pettyCashTypeLabel = util.getLabel(util.pettyCashTypes, item.pettyCashType);
            return item;
        })
        return data;
    }

    render() {
        return (
            <MainTable
                divClassName="cash"
                tableName="Pénztár"
                newObjectLabel="Új korrekció hozzáadása"
                path='/api/pettycash'
                enrich={this.enrich}
                columns={(refresh) => columns.columns(refresh)}
                dialogContent={(refresh, close) => <Correction refresh={refresh} close={close} type={'CASH'} />}
                needAggregate={false}
            />
        );
    }
}

export default Cash;
